import React from 'react'
import {Box, Text} from 'grommet'
import {Select, Button} from "antd";
import {useAccount} from "wagmi";
import { CopyOutlined } from '@ant-design/icons';
import {toast} from "react-toastify";
import QRCode from "react-qr-code";

export const ReceiveContent = () => {
  const { address: userAddress } = useAccount()

  return <Box gap={'16px'}>
    <Box gap={'8px'}>
      <Text size={'large'}>Receive to</Text>
      <Select
        defaultValue={userAddress}
        disabled={true}
        size={'large'}
        // style={{ width: 120 }}
        onChange={() => {}}
        options={[
          { value: userAddress, label: userAddress },
        ]}
      />
    </Box>
    {userAddress &&
        <Box align={'center'}>
            <QRCode value={userAddress} />
        </Box>
    }
    <Box>
      <Button icon={<CopyOutlined />} onClick={() => {
        if(userAddress) {
          navigator.clipboard.writeText(userAddress)
        }
        toast.success('Address copied')
      }}>
        Copy address
      </Button>
    </Box>
  </Box>
}
